import React from 'react';

const partners = [
  'Four Seasons Hotel',
  'ClickedIn',
  'Lee & Associates',
  'Exemplar',
  'Book It Sports',
  'PostNet',
  'Stokes VW',
  'Stokes Mazda',
  'Stokes Kia',
  'Stokes Honda',
  'Breakaway Financial',
  'Charleston Animal Society',
  'Neal Brothers',
  'Best Buy',
  'OutSta',
  'Town of Hollywood',
  'Bloom',
  'Northwestern Mutual',
  'Edward Jones',
  'Vendome',
  'True North',
  'Bridge Advisors',
  'TCG',
  'Linkup Golf',
  'TM2',
  '5FT View',
  'Bee City Zoo',
  'CyberDyne',
  'Focus KPI',
  'NorthStar',
  'Vision Financial Group',
  'Think Tank',
  'Macmoor Capital'
];

const Partners = () => {
  return (
    <section className="py-24 md:py-32 bg-[#f8f7f4]">
      <div className="px-6 md:px-12 lg:px-24">
        {/* Section title */}
        <div className="mb-16 md:mb-24">
          <h2 className="text-[clamp(3rem,8vw,8rem)] font-light text-gray-300 leading-none tracking-tight">
            <span className="block">OUR</span>
            <span className="block ml-[10%]">CLIENTS</span>
          </h2>
        </div>

        {/* Partners marquee */}
        <div className="overflow-hidden">
          <div className="flex animate-marquee whitespace-nowrap">
            {[...partners, ...partners].map((partner, index) => (
              <div
                key={index}
                className="mx-8 md:mx-16 flex items-center justify-center min-w-[150px]"
              >
                <span className="text-2xl md:text-3xl font-light text-gray-400 hover:text-black transition-colors duration-300 cursor-pointer">
                  {partner}
                </span>
              </div>
            ))}
          </div>
        </div>

        {/* Second row - reversed */}
        <div className="overflow-hidden mt-8">
          <div className="flex animate-marquee-reverse whitespace-nowrap">
            {[...partners.reverse(), ...partners].map((partner, index) => (
              <div
                key={index}
                className="mx-8 md:mx-16 flex items-center justify-center min-w-[150px]"
              >
                <span className="text-2xl md:text-3xl font-light text-gray-400 hover:text-black transition-colors duration-300 cursor-pointer">
                  {partner}
                </span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Partners;
